import * as Cesium from 'cesium';
import {getCesium, getCesiumScene} from "@/modules/cesium/cesium";
import {getToken} from "@/helpers/auth/auth-helper";
import {ShadowMode} from "cesium";

window.tileLayers3D = []

export function addService3DTileSet(service) {
    window.tileLayers3D.push(service)

    if(getCesium()) {
        service.index = getCesiumScene().primitives.length
        add3DTileSetToCesium(service.service).then((tileSet) => {

            getCesiumScene().primitives.add(tileSet)

            let opacity = 1
            if (service.service.Opacity) {
                opacity = service.service.Opacity / 10
            }
            generate3DTileStyle(service.service, tileSet, opacity)

            window.tileLayers3D[service.index - 1].tileSet = tileSet
        })
    }
}

export function getService3DTileSetByID(id, toggleHide = false) {
    const tileLayer = window.tileLayers3D.find(tileLayers3D => parseInt(tileLayers3D.id) === parseInt(id))
    if(toggleHide && getCesium() && tileLayer) {
        showHideService3DTileSet(tileLayer)
    }
    return tileLayer
}

export function showHideService3DTileSet(tileLayer) {
    const primitive = getCesiumScene().primitives.get(tileLayer.index)
    if(primitive) {
        primitive.show = !primitive.show
    }
}

export function init3DTileLayers() {

    window.tileLayers3D.map((tileLayers3D, key) => {
        tileLayers3D.index = getCesiumScene().primitives.length
        add3DTileSetToCesium(tileLayers3D.service).then((tileSet) => {

            const service = tileLayers3D.service
            getCesiumScene().primitives.add(tileSet)

            let opacity = 1
            if (service.Opacity) {
                opacity = service.Opacity / 10
            }
            generate3DTileStyle(service, tileSet, opacity)

            window.tileLayers3D[key].tileSet = tileSet
        })
    })
}

export async function add3DTileSetToCesium(service) {

    const url = service.Url

    if(url === 'GooglePhotorealistic3D') {
        return Cesium.createGooglePhotorealistic3DTileset()
    }

    if(Number.isInteger(url)) {
        return Cesium.Cesium3DTileset.fromIonAssetId(url, {
            pointCloudShading: {
                maximumAttenuation: undefined,
                baseResolution: undefined,
                geometricErrorScale: 1,
                attenuation: true,
                eyeDomeLighting: true
            }
        })
    }

    const headers = {}

    if(service.Service.Password) {
        let username = service.Service.Username;
        let password = service.Service.Password;
        let auth = btoa(`${username}:${password}`);
        headers.Authorization = `Basic ${auth}`
    }

    const resource = new Cesium.Resource({
        url: url,
        headers: headers
    })
    return Cesium.Cesium3DTileset.fromUrl(resource, {
        show: true,

        dynamicScreenSpaceError: true,
        dynamicScreenSpaceErrorDensity: 0.00278,
        dynamicScreenSpaceErrorFactor: 4.0,
        dynamicScreenSpaceErrorHeightFalloff: 0.25,

        skipLevelOfDetail: true,
        baseScreenSpaceError: 1024,
        skipScreenSpaceErrorFactor: 16,
        skipLevels: 1,
        immediatelyLoadDesiredLevelOfDetail: false,
        loadSiblings: false,
        cullWithChildrenBounds: true,
        shadows: ShadowMode.ENABLED,
        showOutline: true,
        style: undefined,
        pointCloudShading: {
            maximumAttenuation: undefined,
            baseResolution: undefined,
            geometricErrorScale: 1,
            attenuation: true,
            eyeDomeLighting: true
        },
    })
}

export function update3DTileSetAttribute(bookmarkPresentationID, attribute, value) {
    const tileLayer = window.tileLayers3D.find(tileLayers3D => parseInt(tileLayers3D.id) === bookmarkPresentationID)
    if(tileLayer) {
        switch (attribute) {
            case 'opacity':
                generate3DTileStyle(tileLayer.service, tileLayer.tileSet, value)
                break;
        }
    }
}

// https://github.com/CesiumGS/3d-tiles/tree/main/specification/Styling#conditions
/**
 * generate3DTileStyle
 * @param service
 * @param tileSet
 * @param opacity
 */
export function generate3DTileStyle(service, tileSet, opacity) {
    if(service && service.WfsStyle) {

        if(service.WfsStyle.styles.length > 0) {
            const conditions = []
            service.WfsStyle.styles.map((style) => {
                const color = style.style_settings.fillColor
                conditions.push(["${" + service.WfsStyle.attribute + "} === '" + style.Name + "'", 'color("' + color + '", ' + opacity + ')'])
            })

            tileSet.style = new Cesium.Cesium3DTileStyle({
                color: {
                    conditions: conditions
                },
                anchorLineColor: 'color("black")'
            })
        } else {
            if(opacity === 1) {
                tileSet.style = undefined
            } else {
                tileSet.style = new Cesium.Cesium3DTileStyle({
                    color: "color('#FFFFFF', " + opacity + ")",
                })
            }
        }
    }
}

export function zoomToTileLayerByBookmarkPresentationID(id) {
    const tileLayer = getService3DTileSetByID(id)
    getCesiumScene().camera.flyToBoundingSphere(tileLayer?.tileSet?.boundingSphere)
}
